import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

const LazyAdminPresales = lazy(
  () => import(/* webpackChunkName: 'AdminPresales' */ './index'),
);

export default function AdminPresales() {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyAdminPresales />
    </Suspense>
  );
}
